import CargoCompanyOrderBillingsDownloadRequest, {
  CargoCompanyOrderBillingsDownloadRequestOrder,
  CargoCompanyOrderBillingsDownloadRequestStatus,
} from "../../../../api/raily/cargo-company/order-billings/download/cargo-company-order-billings-download.request";
import BillingStatus from "../../../../types/billing-status";
import CargoCompanyOrder from "../../../../types/cargo-company-order";
import CargoCompanyOrderBillingsDownloadParams from "./cargo-company-order-billings-download-params";

const createStatus = (
  status: BillingStatus | undefined,
): CargoCompanyOrderBillingsDownloadRequestStatus | undefined => {
  switch (status) {
    case BillingStatus.CREATED:
      return CargoCompanyOrderBillingsDownloadRequestStatus.CREATED;
    case BillingStatus.ACCEPTED:
      return CargoCompanyOrderBillingsDownloadRequestStatus.ACCEPTED;
    case BillingStatus.REJECTED:
      return CargoCompanyOrderBillingsDownloadRequestStatus.REJECTED;
    case BillingStatus.REOPEN_REQUEST:
      return CargoCompanyOrderBillingsDownloadRequestStatus.REOPEN_REQUEST;
    case BillingStatus.REOPENED:
      return CargoCompanyOrderBillingsDownloadRequestStatus.REOPENED;
    default:
      return undefined;
  }
};

const createOrder = (
  order: CargoCompanyOrder | undefined,
): CargoCompanyOrderBillingsDownloadRequestOrder | undefined => {
  switch (order) {
    case CargoCompanyOrder.DATE_DESC:
      return CargoCompanyOrderBillingsDownloadRequestOrder.DATE_DESC;
    case CargoCompanyOrder.DATE_ASC:
      return CargoCompanyOrderBillingsDownloadRequestOrder.DATE_ASC;
    case CargoCompanyOrder.HUMAN_ID_ASC:
      return CargoCompanyOrderBillingsDownloadRequestOrder.HUMAN_ID_ASC;
    case CargoCompanyOrder.HUMAN_ID_DESC:
      return CargoCompanyOrderBillingsDownloadRequestOrder.HUMAN_ID_DESC;
    case CargoCompanyOrder.TAXI_CORPORATION_ASC:
      return CargoCompanyOrderBillingsDownloadRequestOrder.TAXI_CORPORATION_ASC;
    case CargoCompanyOrder.TAXI_CORPORATION_DESC:
      return CargoCompanyOrderBillingsDownloadRequestOrder.TAXI_CORPORATION_DESC;
    case CargoCompanyOrder.EXTERNAL_ORDER_ID_ASC:
      return CargoCompanyOrderBillingsDownloadRequestOrder.EXTERNAL_ORDER_ID_ASC;
    case CargoCompanyOrder.EXTERNAL_ORDER_ID_DESC:
      return CargoCompanyOrderBillingsDownloadRequestOrder.EXTERNAL_ORDER_ID_DESC;
    case CargoCompanyOrder.DISPATCH_ASC:
      return CargoCompanyOrderBillingsDownloadRequestOrder.DISPATCH_ASC;
    case CargoCompanyOrder.DISPATCH_DESC:
      return CargoCompanyOrderBillingsDownloadRequestOrder.DISPATCH_DESC;
    case CargoCompanyOrder.DISTANCE_ASC:
      return CargoCompanyOrderBillingsDownloadRequestOrder.DISTANCE_ASC;
    case CargoCompanyOrder.DISTANCE_DESC:
      return CargoCompanyOrderBillingsDownloadRequestOrder.DISTANCE_DESC;
    case CargoCompanyOrder.DISTANCE_RATE_ASC:
      return CargoCompanyOrderBillingsDownloadRequestOrder.DISTANCE_RATE_ASC;
    case CargoCompanyOrder.DISTANCE_RATE_DESC:
      return CargoCompanyOrderBillingsDownloadRequestOrder.DISTANCE_RATE_DESC;
    case CargoCompanyOrder.DISTANCE_AMOUNT_ASC:
      return CargoCompanyOrderBillingsDownloadRequestOrder.DISTANCE_AMOUNT_ASC;
    case CargoCompanyOrder.DISTANCE_AMOUNT_DESC:
      return CargoCompanyOrderBillingsDownloadRequestOrder.DISTANCE_AMOUNT_DESC;
    case CargoCompanyOrder.HALTING_HOURS_ASC:
      return CargoCompanyOrderBillingsDownloadRequestOrder.HALTING_HOURS_ASC;
    case CargoCompanyOrder.HALTING_HOURS_DESC:
      return CargoCompanyOrderBillingsDownloadRequestOrder.HALTING_HOURS_DESC;
    case CargoCompanyOrder.HALTING_AMOUNT_ASC:
      return CargoCompanyOrderBillingsDownloadRequestOrder.HALTING_AMOUNT_ASC;
    case CargoCompanyOrder.HALTING_AMOUNT_DESC:
      return CargoCompanyOrderBillingsDownloadRequestOrder.HALTING_AMOUNT_DESC;
    case CargoCompanyOrder.HIGHWAY_CHARGE_ASC:
      return CargoCompanyOrderBillingsDownloadRequestOrder.HIGHWAY_CHARGE_ASC;
    case CargoCompanyOrder.HIGHWAY_CHARGE_DESC:
      return CargoCompanyOrderBillingsDownloadRequestOrder.HIGHWAY_CHARGE_DESC;
    case CargoCompanyOrder.DISCOUNT_ASC:
      return CargoCompanyOrderBillingsDownloadRequestOrder.DISCOUNT_ASC;
    case CargoCompanyOrder.DISCOUNT_DESC:
      return CargoCompanyOrderBillingsDownloadRequestOrder.DISCOUNT_DESC;
    case CargoCompanyOrder.DISCOUNT_AMOUNT_ASC:
      return CargoCompanyOrderBillingsDownloadRequestOrder.DISCOUNT_AMOUNT_ASC;
    case CargoCompanyOrder.DISCOUNT_AMOUNT_DESC:
      return CargoCompanyOrderBillingsDownloadRequestOrder.DISCOUNT_AMOUNT_DESC;
    case CargoCompanyOrder.TOTAL_AMOUNT_ASC:
      return CargoCompanyOrderBillingsDownloadRequestOrder.TOTAL_AMOUNT_ASC;
    case CargoCompanyOrder.TOTAL_AMOUNT_DESC:
      return CargoCompanyOrderBillingsDownloadRequestOrder.TOTAL_AMOUNT_DESC;
    default:
      return undefined;
  }
};

const create = (
  params: CargoCompanyOrderBillingsDownloadParams,
): CargoCompanyOrderBillingsDownloadRequest => {
  return {
    address: params.address,
    date_since: params.date_since,
    company_id: params.company_id,
    date_to: params.date_to,
    dispatch: params.dispatch,
    end_address: params.end_address,
    external_id: params.external_id,
    human_id: params.human_id,
    mid_address: params.mid_address,
    order: createOrder(params.order),
    passenger: params.passenger,
    start_address: params.start_address,
    status: createStatus(params.status),
    taxi: params.taxi,
  };
};

const cargoCompanyOrderBillingsDownloadParamsFactory = {
  create,
};

export default cargoCompanyOrderBillingsDownloadParamsFactory;
